export default __webpack_public_path__ + "static/media/ai_face_recognition.ca5fbbb2.svg";